import React, { memo, useCallback, useEffect, useMemo } from 'react';

import { useHistory } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';

import pageUrls from '@/constants/pageUrls';
import statusType from '@/store/constants/statusType';
import { editTechnoCompany, getTechnoCompany } from '@/store/actions/companyActions';

import CompanyEditForm from '../components/CompanyEditForm';
import TechnoContactFields from '../components/TechnoContactFields';

const TechnoCompanyEdit = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  const { data: account } = useSelector(state => state.account);
  const id = useMemo(() => account?.companyId, [account?.companyId]);

  const { edit: { status: editStatus, error: editError } = {}, get: { data: company } = {} } = useSelector(
    state => state.technoCompany
  );

  const handleClickCancel = useCallback(() => {
    history.push(pageUrls.COMPANY.MY);
  }, [history]);

  const handleClickSave = useCallback(
    fields => {
      const { addresses, general, contacts } = fields;

      if (contacts) {
        dispatch(editTechnoCompany({ data: { contacts }, id }));
      } else {
        dispatch(
          editTechnoCompany({
            data: {
              addresses: { addresses, sameMailAddress: general.sameMailAddress },
              general: { general: { ...company.general, ...general } },
            },
            id,
          })
        );
      }
    },
    [dispatch, company, id]
  );

  useEffect(() => {
    if (editStatus === statusType.SUCCESSED) {
      history.push(pageUrls.COMPANY.MY);
    }
  }, [editStatus, history]);

  useEffect(() => {
    if (id) {
      dispatch(getTechnoCompany(id));
    }
  }, [dispatch, id]);

  return (
    <CompanyEditForm
      error={editError}
      excludeFields={['transportsAvailable', 'transportationType', 'transports']}
      company={company}
      loading={editStatus === statusType.LOADING}
      contactFields={<TechnoContactFields />}
      onSave={handleClickSave}
      onCancel={handleClickCancel}
    />
  );
};

export default memo(TechnoCompanyEdit);
